import { getToken } from "../services/authUtil";
const API_BASE_URL = process.env.REACT_APP_BASE_URL;

export const getInventoryAvailability = async (resortId, viewType, date) => {
  try {
    const token = getToken();
    const response = await fetch(
      `${API_BASE_URL}/resort/inventory/${resortId}/${viewType}/${date}`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    const data = await response.json();
    if (response.ok) {
      return data;
    }
    throw new Error(data.message || "Failed to fetch inventory");
  } catch (error) {
    throw new Error(error.message || "Failed to fetch inventory");
  }
};
